import React from 'react';
import './ProductsFilter.css';
import { CATEGORIES, BRANDS } from './productData';

export default function ProductsFilter({
  activeCategory,
  setActiveCategory,
  activeBrand,
  setActiveBrand,
  sortBy,
  setSortBy,
  totalCount,
}) {
  return (
    <div className="pf">
      <div className="pf__inner">

        {/* Category pills */}
        <div className="pf__categories">
          {CATEGORIES.map(cat => (
            <button
              key={cat}
              className={`pf__cat${activeCategory === cat ? ' pf__cat--on' : ''}`}
              onClick={() => setActiveCategory(cat)}
            >
              {cat}
            </button>
          ))}
        </div>

        {/* Right: brand select + sort + count */}
        <div className="pf__right">
          <span className="pf__count">{totalCount} styles</span>

          <select
            className="pf__select"
            value={activeBrand}
            onChange={e => setActiveBrand(e.target.value)}
          >
            {BRANDS.map(b => <option key={b}>{b}</option>)}
          </select>

          <select
            className="pf__select"
            value={sortBy}
            onChange={e => setSortBy(e.target.value)}
          >
            <option value="featured">Featured</option>
            <option value="price-asc">Price: Low to High</option>
            <option value="price-desc">Price: High to Low</option>
            <option value="name">Name</option>
          </select>
        </div>
      </div>
    </div>
  );
}